import { INSIGHTS } from "constants/action-types";

export const fetchProductColorInsights = (viewAsCompanyId: string = null) => ({
    type: INSIGHTS.FETCH_PRODUCT_COLOR_INSIGHTS.START,
    payload: {
        viewAsCompanyId,
    },
});
